import React from "react";
import { Page, Text, View, Image, Font } from "@react-pdf/renderer";
import logo from "../../logo-succession-now.png";
import Shape from "../../shape.png";
import moment from "moment/moment";

import RobotoLight from "../../assets/font/Roboto-Light.ttf";
import RobotoRegular from "../../assets/font/Roboto-Regular.ttf";
import RobotoItalic from "../../assets/font/Roboto-Italic.ttf";
import RobotoMedium from "../../assets/font/Roboto-Medium.ttf";
import RobotoBold from "../../assets/font/Roboto-Bold.ttf";

Font.register({ family: "RobotoLight", src: RobotoLight });
Font.register({ family: "RobotoRegular", src: RobotoRegular });
Font.register({ family: "RobotoItalic", src: RobotoItalic });
Font.register({ family: "RobotoMedium", src: RobotoMedium });
Font.register({ family: "RobotoBold", src: RobotoBold });

const BoardPositionReport = ({ data, user, companyLogo }) => {
  const splitToList = (text) =>
    text
      .split("\n")
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
  return (
    <Page
      size="A4"
      orientation="landscape"
      style={{
        padding: 20,
        fontFamily: "RobotoRegular",
        lineHeight: 1.2,
        fontSize: 9,
        color: "#334155",
        backgroundColor: "#f1f5f9",
      }}
    >
      <View
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
        }}
        fixed
      >
        <View
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            width: "100%",
            height: 160,
            zIndex: -1,
            opacity: 0.1,
          }}
        >
          <Image style={{ objectFit: "cover" }} src={Shape} />
        </View>
        <View
          style={{
            position: "absolute",
            width: "100%",
            left: 0,
            bottom: -10,
            right: 0,
            height: 160,
            zIndex: -1,
            opacity: 0.075,
          }}
        >
          <Image style={{ objectFit: "contain" }} src={logo} />
        </View>
      </View>
      <View style={{ position: "absolute", right: 30, top: 30 }}>
        <Image
          style={{ width: 120, height: 24, objectFit: "contain" }}
          src={logo}
        />
      </View>
      <View
        style={{
          paddingBottom: 20,
          width: "100%",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <View
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            fontSize: 16,
            alignItems: "center",
            position: "relative",
            width: "100%",
          }}
        >
          <Image
            style={{
              width: 360,
              height: 120,
              objectFit: "contain",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            src={companyLogo}
          />
        </View>
        <View style={{ display: "flex", flexDirection: "row", marginTop: 15 }}>
          <Text
            style={{
              fontFamily: "RobotoBold",
              fontSize: 20,
              textTransform: "capitalize",
            }}
          >
            Company Name: {user?.company_name}
          </Text>
        </View>
        <View
          style={[{ display: "flex", flexDirection: "row", marginTop: 15 }]}
        >
          <Text
            style={{
              fontFamily: "RobotoBold",
              fontSize: 12,
              textTransform: "uppercase",
              color: "#14b8a6",
              letterSpacing: 3,
              textAlign: "center",
            }}
          >
            Board Positions Report
          </Text>
        </View>
        <View
          style={[
            {
              display: "flex",
              flexDirection: "row",
              marginTop: 5,
              textAlign: "center",
              justifyContent: "center",
            },
          ]}
        >
          <View
            style={[
              {
                display: "flex",
                flexDirection: "row",
                marginTop: 5,
                textAlign: "center",
                justifyContent: "center",
                marginRight: 12,
              },
            ]}
          >
            <Text
              style={[
                {
                  fontFamily: "RobotoMedium",
                  fontSize: 10,
                  textAlign: "center",
                },
              ]}
            >
              Created by:
            </Text>
            <Text
              style={{
                fontFamily: "RobotoRegular",
                fontSize: 10,
                marginLeft: 2,
              }}
            >
              {user?.name}({user?.title})
            </Text>
          </View>
          <View
            style={[{ display: "flex", flexDirection: "row", marginTop: 5 }]}
          >
            <Text style={[{ fontFamily: "RobotoMedium", fontSize: 10 }]}>
              Date:
            </Text>
            <Text
              style={{
                fontFamily: "RobotoRegular",
                fontSize: 10,
                marginLeft: 2,
              }}
            >
              {moment(new Date()).format("MM/DD/YYYY")}
            </Text>
          </View>
        </View>
      </View>

      <View style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {data.length > 0 &&
          data.map((item, index) => (
            <View
              key={index}
              style={{
                marginTop: 12,
                borderWidth: 1,
                borderColor: "#e5e7eb",
                borderRadius: 12,
                padding: 14,
                backgroundColor: "#ffffff",
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.05,
                shadowRadius: 4,
                elevation: 2,
              }}
            >
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: "RobotoBold",
                  textDecorationLine: "underline",
                  marginBottom: 8,
                }}
              >
                {item.name}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: "RobotoBold",
                  color: "#0d9488",
                  marginBottom: 4,
                }}
              >
                Position Summary
              </Text>
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: "RobotoRegular",
                  color: "#374151",
                  marginBottom: 12,
                }}
              >
                {item?.position_competencies || "N/A"}
              </Text>

              <Text
                style={{
                  fontSize: 12,
                  fontFamily: "RobotoBold",
                  color: "#0d9488",
                  marginBottom: 4,
                }}
              >
                Key Responsibilities
              </Text>
              {item?.key_responsibilities &&
              Array.isArray(item.key_responsibilities) &&
              item.key_responsibilities.length > 0 ? (
                item.key_responsibilities.map((section, i) => (
                  <View key={i} style={{ marginBottom: 10 }}>
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: "RobotoMedium",
                        color: "#1f2937",
                        borderBottomWidth: 1,
                        borderBottomColor: "#cbd5e1",
                        paddingBottom: 2,
                        marginBottom: 4,
                      }}
                    >
                      {section?.title || "N/A"}
                    </Text>
                    {splitToList(section?.description).map((point, idx) => (
                      <Text
                        key={idx}
                        style={{
                          fontSize: 10,
                          fontFamily: "RobotoRegular",
                          color: "#374151",
                          marginBottom: 2,
                        }}
                      >
                        • {point}
                      </Text>
                    ))}
                  </View>
                ))
              ) : (
                <Text
                  style={{ fontSize: 10, color: "#6b7280", marginBottom: 12 }}
                >
                  N/A
                </Text>
              )}
              {item?.qualifications && (
                <View style={{ marginBottom: 12 }}>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: "RobotoBold",
                      color: "#0d9488",
                      marginBottom: 4,
                    }}
                  >
                    Qualifications
                  </Text>
                  {splitToList(item.qualifications).map((qual, idx) => (
                    <Text
                      key={idx}
                      style={{
                        fontSize: 10,
                        fontFamily: "RobotoRegular",
                        color: "#374151",
                        marginBottom: 2,
                      }}
                    >
                       {qual}
                    </Text>
                  ))}
                </View>
              )}
              {item?.time_commitment && (
                <View style={{ marginTop: 2 }}>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: "RobotoBold",
                      color: "#0d9488",
                      marginBottom: 4,
                    }}
                  >
                    Time Commitment
                  </Text>
                  {splitToList(item.time_commitment).map((time, idx) => (
                    <Text
                      key={idx}
                      style={{
                        fontSize: 10,
                        fontFamily: "RobotoRegular",
                        color: "#374151",
                        marginBottom: 2,
                      }}
                    >
                       {time}
                    </Text>
                  ))}
                </View>
              )}
            </View>
          ))}
      </View>
    </Page>
  );
};

export default BoardPositionReport;
